const lines = (value) => value.trim().split("\n");

export const featureFilters = {
  genes: lines(`
Ackr4
Acta2
Actc1
Acvr1
Acvr2a
Adamts6
Adamts8
Adap2
Adgrd1
Adora1
Agrn
Angpt1
Angpt2
Angptl2
Ankrd1
Aplnr
Atad2
Atf1
Atf3
Axl
Bach1
Bcl11a
Bcl6
Bdp1
Bgn
Bin1
Bmp5
Bmp6
Bmpr1a
Bmpr1b
Bmpr2
Cacan1c_exon9_1
Cacan1c_exon9_2
Cacan1c_woexon9
Cacna1d
Cadm1
Calcrl
Camk2d_E
Camk2d_M_1
Camk2d_M_2
Car4
Ccl25
Cd200
Cd200r1
Cd22
Cd244a
Cd28
Cd34
Cd36
Cd44
Cd46
Cd47
Cd48
Cd8b1
Cdca2
Cdh1
Cdh11
Cdh19
Cdh2
Cdh4
Cdh5
Cebpa
Cebpb
Celf4
Cenpe
Cenpf
Chrm3
Cmklr1
Cnn1
Cntn2
Col1a1
Col1a2
Col24a1
Col3a1
Col4a1
Col4a2
Col4a3
Col4a4
Col4a5
Col4a6
Col6a1
Col6a2
Col6a3
Col6a6
Col8a1
Cox5a
Cpe
Cpeb1
Cpne5
Cpt1b
Creb5
Csf1
Csf1r
Cspg4
Csrp2
Cxcl12
Dach1
Dag1
Dbp
Dcn
Ddc
Dgkb
Dkk3
Dll4
Dnmt3a
Dsc2
Dsg2
Eda
Edar
Efnb2
Egf
Egfr
Elf2
Eln
Entpd1
Epha3
Epha4
Epha7
Ephb1
Ephb2
Ephb3
Ephb4
Erbb3
Erbb4
Erg
Esam
Esrra
Esrrb
Esrrg
Ezh2
F11r
Fbln1
Fbln2
Fgf1
Fgf2
Fgf9
Fgfr1
Fgfr2
Fli1
Flt1
Flt4
Fn1
Fndc1
Foxo3
Fyb
Fzd4
Fzd6
Gabpa
Gas6
Gfpt2
Gja4
Gja5
Gm12381
Gm5127
Grn
H2afv
Hbegf
Hells
Hey1
Hey2
Hjurp
Hsd11b1
Hspg2
Htra3
Igf1
Igf1r
Igf2
Igf2r
Igfbp3
Igfbp5
Igsf11
Il34
Insr
Iqgap2
Irx2
Itga1
Itga10
Itga3
Itga4
Itga5
Itga6
Itga7
Itga8
Itga9
Itgav
Itgb1
Itgb3
Itgb4
Itgb5
Itgb6
Itgb8
Itgbl1
Ivns1abp
Jag1
Jam2
Jam3
Jph1
Jph2
Jun
Kcnj2
Kcnq1
Kcnq5
Kdr
Kif11
Kif15
Kirrel3
Kit
Kitl
Klf15
L1cam
Lama3
Lama4
Lama5
Lamb1
Lamb2
Lamb3
Lamc1
Lgals9
Lhx6
Lims2
Lpin1
Lrp5
Lrp6
Lrrc4
Lrrc4c
Lsamp
Lum
Lyve1
Mapk10
Max
Mb
Mcam
Meox1
Mertk
Mest
Mitf
Mki67
Mmp2
Mpzl1
Mrc1
Muc16
Mybphl
Myh11
Myh6
Myh7
Myl2
Myl4
Myl7
Myl9
Mylk
Myom1_E_1
Myom1_E_2
Myom1_M
Nampt
Ncam1
Ncam2
Ncl
Nectin3
Negr1
Nfe2l1
Nlgn3
Notch1
Notch2
Notch3
Notch4
Nppa
Npr1
Npr3
Nr1d2
Nr2f2
Nr3c2
Nrg1
Nrg2
Nrp1
Nrxn1
Nrxn3
Nsdhl
Ntf3
Ntm
Ntng1
Ntng2
Ntrk2
Ntrk3
Pcdh15
Pcdh17
Pcdh9
Pdgfa
Pdgfb
Pdgfc
Pdgfd
Pdgfra
Pdgfrb
Pdlim3
Pdlim5_long
Pdlim5_short
Pdpn
Pecam1
Pi16
Pirb
Pln
Plxna2
Plxna4
Plxnc1
Plxnd1
Pola1
Postn
Ppara
Ppard
Ppargc1a
Ppargc1b
Prdm16
Pros1
Prox1
Ptger4
Ptges2
Ptn
Ptprc
Ptprm
Ptprz1
Pvr
Rad21
Rad51b
Rarres2
Reln
Rgcc
Rgs5
Robo1
Rorb
Rreb1
Rrm1
Runx1
Rxrg
Ryr2_iso2
Ryr2_iso3
Sdc2
Sdc4
Sema3a
Sema3c
Sema3e
Sema4a
Sema6a
Sema7a
Slc45a4
Slit2
Smc4
Sort1
Sox4
Sparcl1
Stat5a
Stat5b
Stmn1
Tacc2
Tagln
Tbx3
Tcf21
Tek
Tgfa
Tgfb1
Tgfb2
Tgfbr1
Tgfbr2
Thbs1
Thrb
Thsd4
Tie1
Tlr4
Tnc
Tnfrsf11a
Tnfrsf11b
Tnfsf11
Tnni3
Tnnt2
Tnr
Tnxb
Top2a
Tpm2_6a_1
Tpm2_6a_2
Tpm2_6b_1
Tpm2_6b_2
Trpc3
Ttn_N2B
Ttn_N2BA_1
Ttn_N2BA_2
Unc5b
Upk3b
Vcam1
Vcan
Vegfa
Vegfb
Vegfc
Vegfd
Vsir
Vtn
Vwf
Wdr76
Wnt5a
Wnt5b
Wnt9a
Wt1
Zfp366
Zfp612
cTnT_E
cTnT_M
  `),
  cc: lines(`
CC_Direct_AGRN
CC_Direct_Agrn.Dag1
CC_Direct_CADM
CC_Direct_CD200
CC_Direct_CD22
CC_Direct_CD39
CC_Direct_CD45
CC_Direct_CD46
CC_Direct_CD48
CC_Direct_CDH
CC_Direct_CDH5
CC_Direct_CNTN
CC_Direct_COLLAGEN
CC_Direct_CSPG4
CC_Direct_Cadm1.Cadm1
CC_Direct_Cd200.Cd200r1
CC_Direct_Cd22.Ptprc
CC_Direct_Cd46.Jag1
CC_Direct_Cd48.Cd244a
CC_Direct_Cdh1.Cdh1
CC_Direct_Cdh2.Cdh2
CC_Direct_Cdh4.Cdh4
CC_Direct_Cdh5.Cdh5
CC_Direct_Cntn2.Cntn2
CC_Direct_Cntn2.L1cam
CC_Direct_Col1a1.Cd44
CC_Direct_Col1a1.Itga10_Itgb1
CC_Direct_Col1a1.Itga1_Itgb1
CC_Direct_Col1a1.Itga3_Itgb1
CC_Direct_Col1a1.Itga9_Itgb1
CC_Direct_Col1a1.Itgav_Itgb8
CC_Direct_Col1a1.Sdc4
CC_Direct_Col1a2.Cd44
CC_Direct_Col1a2.Itga10_Itgb1
CC_Direct_Col1a2.Itga1_Itgb1
CC_Direct_Col1a2.Itga3_Itgb1
CC_Direct_Col1a2.Itga9_Itgb1
CC_Direct_Col1a2.Itgav_Itgb8
CC_Direct_Col1a2.Sdc4
CC_Direct_Col4a1.Cd44
CC_Direct_Col4a1.Itga10_Itgb1
CC_Direct_Col4a1.Itga1_Itgb1
CC_Direct_Col4a1.Itga3_Itgb1
CC_Direct_Col4a1.Itga9_Itgb1
CC_Direct_Col4a1.Itgav_Itgb8
CC_Direct_Col4a1.Sdc4
CC_Direct_Col4a2.Cd44
CC_Direct_Col4a2.Itga10_Itgb1
CC_Direct_Col4a2.Itga1_Itgb1
CC_Direct_Col4a2.Itga3_Itgb1
CC_Direct_Col4a2.Itga9_Itgb1
CC_Direct_Col4a2.Itgav_Itgb8
CC_Direct_Col4a2.Sdc4
CC_Direct_Col4a3.Cd44
CC_Direct_Col4a3.Itga10_Itgb1
CC_Direct_Col4a3.Itga1_Itgb1
CC_Direct_Col4a3.Itga3_Itgb1
CC_Direct_Col4a3.Itga9_Itgb1
CC_Direct_Col4a3.Itgav_Itgb8
CC_Direct_Col4a3.Sdc4
CC_Direct_Col4a4.Cd44
CC_Direct_Col4a4.Itga10_Itgb1
CC_Direct_Col4a4.Itga1_Itgb1
CC_Direct_Col4a4.Itga3_Itgb1
CC_Direct_Col4a4.Itga9_Itgb1
CC_Direct_Col4a4.Itgav_Itgb8
CC_Direct_Col4a4.Sdc4
CC_Direct_Col4a5.Cd44
CC_Direct_Col4a5.Itga10_Itgb1
CC_Direct_Col4a5.Itga1_Itgb1
CC_Direct_Col4a5.Itga3_Itgb1
CC_Direct_Col4a5.Itga9_Itgb1
CC_Direct_Col4a5.Itgav_Itgb8
CC_Direct_Col4a5.Sdc4
CC_Direct_Col4a6.Cd44
CC_Direct_Col4a6.Itga10_Itgb1
CC_Direct_Col4a6.Itga1_Itgb1
CC_Direct_Col4a6.Itga3_Itgb1
CC_Direct_Col4a6.Itga9_Itgb1
CC_Direct_Col4a6.Itgav_Itgb8
CC_Direct_Col4a6.Sdc4
CC_Direct_Col6a1.Cd44
CC_Direct_Col6a1.Itga10_Itgb1
CC_Direct_Col6a1.Itga1_Itgb1
CC_Direct_Col6a1.Itga3_Itgb1
CC_Direct_Col6a1.Itga9_Itgb1
CC_Direct_Col6a1.Itgav_Itgb8
CC_Direct_Col6a1.Sdc4
CC_Direct_Col6a2.Cd44
CC_Direct_Col6a2.Itga10_Itgb1
CC_Direct_Col6a2.Itga1_Itgb1
CC_Direct_Col6a2.Itga3_Itgb1
CC_Direct_Col6a2.Itga9_Itgb1
CC_Direct_Col6a2.Itgav_Itgb8
CC_Direct_Col6a2.Sdc4
CC_Direct_Col6a3.Cd44
CC_Direct_Col6a3.Itga10_Itgb1
CC_Direct_Col6a3.Itga1_Itgb1
CC_Direct_Col6a3.Itga3_Itgb1
CC_Direct_Col6a3.Itga9_Itgb1
CC_Direct_Col6a3.Itgav_Itgb8
CC_Direct_Col6a3.Sdc4
CC_Direct_Col6a6.Cd44
CC_Direct_Col6a6.Itga10_Itgb1
CC_Direct_Col6a6.Itga1_Itgb1
CC_Direct_Col6a6.Itga3_Itgb1
CC_Direct_Col6a6.Itga9_Itgb1
CC_Direct_Col6a6.Itgav_Itgb8
CC_Direct_Col6a6.Sdc4
CC_Direct_Cspg4.Itga3_Itgb1
CC_Direct_DESMOSOME
CC_Direct_Dll4.Notch1
CC_Direct_Dll4.Notch2
CC_Direct_Dll4.Notch3
CC_Direct_Dll4.Notch4
CC_Direct_Dsc2.Dsg2
CC_Direct_EPHB
CC_Direct_ESAM
CC_Direct_Efnb2.Epha4
CC_Direct_Efnb2.Ephb1
CC_Direct_Efnb2.Ephb2
CC_Direct_Efnb2.Ephb3
CC_Direct_Efnb2.Ephb4
CC_Direct_Entpd1.Adora1
CC_Direct_Esam.Esam
CC_Direct_F11r.F11r
CC_Direct_F11r.Jam2
CC_Direct_F11r.Jam3
CC_Direct_FN1
CC_Direct_Fn1.Cd44
CC_Direct_Fn1.Itga3_Itgb1
CC_Direct_Fn1.Itga4_Itgb1
CC_Direct_Fn1.Itga5_Itgb1
CC_Direct_Fn1.Itga8_Itgb1
CC_Direct_Fn1.Itgav_Itgb1
CC_Direct_Fn1.Itgav_Itgb3
CC_Direct_Fn1.Itgav_Itgb6
CC_Direct_Fn1.Itgav_Itgb8
CC_Direct_Fn1.Sdc4
CC_Direct_HSPG
CC_Direct_Hspg2.Dag1
CC_Direct_Itga4_Itgb1.Vcam1
CC_Direct_Itga9_Itgb1.Vcam1
CC_Direct_JAM
CC_Direct_Jag1.Notch1
CC_Direct_Jag1.Notch2
CC_Direct_Jag1.Notch3
CC_Direct_Jag1.Notch4
CC_Direct_Jam2.F11r
CC_Direct_Jam2.Itga3_Itgb1
CC_Direct_Jam2.Itgav_Itgb1
CC_Direct_Jam2.Jam2
CC_Direct_Jam2.Jam3
CC_Direct_Jam3.F11r
CC_Direct_Jam3.Jam2
CC_Direct_Jam3.Jam3
CC_Direct_L1CAM
CC_Direct_L1cam.Itgav_Itgb3
CC_Direct_L1cam.L1cam
CC_Direct_LAMININ
CC_Direct_Lama3.Cd44
CC_Direct_Lama3.Dag1
CC_Direct_Lama3.Itga1_Itgb1
CC_Direct_Lama3.Itga3_Itgb1
CC_Direct_Lama3.Itga6_Itgb1
CC_Direct_Lama3.Itga6_Itgb4
CC_Direct_Lama3.Itga7_Itgb1
CC_Direct_Lama3.Itga9_Itgb1
CC_Direct_Lama3.Itgav_Itgb8
CC_Direct_Lama4.Cd44
CC_Direct_Lama4.Dag1
CC_Direct_Lama4.Itga1_Itgb1
CC_Direct_Lama4.Itga3_Itgb1
CC_Direct_Lama4.Itga6_Itgb1
CC_Direct_Lama4.Itga6_Itgb4
CC_Direct_Lama4.Itga7_Itgb1
CC_Direct_Lama4.Itga9_Itgb1
CC_Direct_Lama4.Itgav_Itgb8
CC_Direct_Lama5.Cd44
CC_Direct_Lama5.Dag1
CC_Direct_Lama5.Itga1_Itgb1
CC_Direct_Lama5.Itga3_Itgb1
CC_Direct_Lama5.Itga6_Itgb1
CC_Direct_Lama5.Itga6_Itgb4
CC_Direct_Lama5.Itga7_Itgb1
CC_Direct_Lama5.Itga9_Itgb1
CC_Direct_Lama5.Itgav_Itgb8
CC_Direct_Lamb1.Cd44
CC_Direct_Lamb1.Dag1
CC_Direct_Lamb1.Itga1_Itgb1
CC_Direct_Lamb1.Itga3_Itgb1
CC_Direct_Lamb1.Itga6_Itgb1
CC_Direct_Lamb1.Itga6_Itgb4
CC_Direct_Lamb1.Itga7_Itgb1
CC_Direct_Lamb1.Itga9_Itgb1
CC_Direct_Lamb1.Itgav_Itgb8
CC_Direct_Lamb2.Cd44
CC_Direct_Lamb2.Dag1
CC_Direct_Lamb2.Itga1_Itgb1
CC_Direct_Lamb2.Itga3_Itgb1
CC_Direct_Lamb2.Itga6_Itgb1
CC_Direct_Lamb2.Itga6_Itgb4
CC_Direct_Lamb2.Itga7_Itgb1
CC_Direct_Lamb2.Itga9_Itgb1
CC_Direct_Lamb2.Itgav_Itgb8
CC_Direct_Lamb3.Cd44
CC_Direct_Lamb3.Dag1
CC_Direct_Lamb3.Itga1_Itgb1
CC_Direct_Lamb3.Itga3_Itgb1
CC_Direct_Lamb3.Itga6_Itgb1
CC_Direct_Lamb3.Itga6_Itgb4
CC_Direct_Lamb3.Itga7_Itgb1
CC_Direct_Lamb3.Itga9_Itgb1
CC_Direct_Lamb3.Itgav_Itgb8
CC_Direct_Lamc1.Cd44
CC_Direct_Lamc1.Dag1
CC_Direct_Lamc1.Itga1_Itgb1
CC_Direct_Lamc1.Itga3_Itgb1
CC_Direct_Lamc1.Itga6_Itgb1
CC_Direct_Lamc1.Itga6_Itgb4
CC_Direct_Lamc1.Itga7_Itgb1
CC_Direct_Lamc1.Itga9_Itgb1
CC_Direct_Lamc1.Itgav_Itgb8
CC_Direct_Lrrc4.Ntng2
CC_Direct_Lrrc4c.Ntng1
CC_Direct_MPZ
CC_Direct_Mpzl1.Mpzl1
CC_Direct_NCAM
CC_Direct_NECTIN
CC_Direct_NEGR
CC_Direct_NGL
CC_Direct_NOTCH
CC_Direct_NRXN
CC_Direct_Ncam1.Fgfr1
CC_Direct_Ncam1.L1cam
CC_Direct_Ncam1.Ncam1
CC_Direct_Ncam1.Ncam2
CC_Direct_Ncam2.L1cam
CC_Direct_Nectin3.Pvr
CC_Direct_Negr1.Negr1
CC_Direct_Nrxn1.Nlgn3
CC_Direct_Nrxn3.Nlgn3
CC_Direct_PECAM1
CC_Direct_PTPRM
CC_Direct_Pecam1.Pecam1
CC_Direct_Ptprc.Cd22
CC_Direct_Ptprc.Mrc1
CC_Direct_Ptprm.Ptprm
CC_Direct_RELN
CC_Direct_Reln.Itga3_Itgb1
CC_Direct_SEMA4
CC_Direct_SEMA6
CC_Direct_SEMA7
CC_Direct_Sema4a.Nrp1_Plxna2
CC_Direct_Sema4a.Nrp1_Plxna4
CC_Direct_Sema6a.Plxna2
CC_Direct_Sema6a.Plxna4
CC_Direct_Sema7a.Itgb1_Itga1
CC_Direct_Sema7a.Plxnc1
CC_Direct_TENASCIN
CC_Direct_THBS
CC_Direct_Thbs1.Cd36
CC_Direct_Thbs1.Cd47
CC_Direct_Thbs1.Itga3_Itgb1
CC_Direct_Thbs1.Itgav_Itgb3
CC_Direct_Thbs1.Sdc4
CC_Direct_Tnc.Itga8_Itgb1
CC_Direct_Tnc.Itga9_Itgb1
CC_Direct_Tnc.Itgav_Itgb3
CC_Direct_Tnc.Itgav_Itgb6
CC_Direct_Tnc.Sdc4
CC_Direct_Tnr.Itga8_Itgb1
CC_Direct_Tnr.Itga9_Itgb1
CC_Direct_Tnr.Itgav_Itgb3
CC_Direct_Tnr.Itgav_Itgb6
CC_Direct_Tnr.Sdc4
CC_Direct_Tnxb.Itga8_Itgb1
CC_Direct_Tnxb.Itga9_Itgb1
CC_Direct_Tnxb.Itgav_Itgb3
CC_Direct_Tnxb.Itgav_Itgb6
CC_Direct_Tnxb.Sdc4
CC_Direct_VCAM
CC_Direct_VISTA
CC_Direct_VTN
CC_Direct_VWF
CC_Direct_Vsir.Igsf11
CC_Direct_Vtn.Itga8_Itgb1
CC_Direct_Vtn.Itgav_Itgb1
CC_Direct_Vtn.Itgav_Itgb3
CC_Direct_Vtn.Itgav_Itgb5
CC_Direct_Vtn.Itgav_Itgb8
CC_Direct_Vwf.Itgav_Itgb3
CC_Direct_total.total
CC_Indirect_ANGPT
CC_Indirect_ANGPTL
CC_Indirect_Angpt1.Tek
CC_Indirect_Angpt2.Itga5_Itgb1
CC_Indirect_Angpt2.Tek
CC_Indirect_Angptl2.Itga5_Itgb1
CC_Indirect_Angptl2.Pirb
CC_Indirect_Angptl2.Tlr4
CC_Indirect_BMP
CC_Indirect_Bmp5.Acvr1_Acvr2a
CC_Indirect_Bmp5.Acvr1_Bmpr2
CC_Indirect_Bmp5.Bmpr1a_Acvr2a
CC_Indirect_Bmp5.Bmpr1a_Bmpr2
CC_Indirect_Bmp5.Bmpr1b_Acvr2a
CC_Indirect_Bmp5.Bmpr1b_Bmpr2
CC_Indirect_Bmp6.Acvr1_Acvr2a
CC_Indirect_Bmp6.Acvr1_Bmpr2
CC_Indirect_Bmp6.Bmpr1a_Acvr2a
CC_Indirect_Bmp6.Bmpr1a_Bmpr2
CC_Indirect_Bmp6.Bmpr1b_Acvr2a
CC_Indirect_Bmp6.Bmpr1b_Bmpr2
CC_Indirect_CCL
CC_Indirect_CHEMERIN
CC_Indirect_CSF
CC_Indirect_Ccl25.Ackr4
CC_Indirect_Csf1.Csf1r
CC_Indirect_EDA
CC_Indirect_EGF
CC_Indirect_Eda.Edar
CC_Indirect_Egf.Egfr
CC_Indirect_FGF
CC_Indirect_Fgf1.Fgfr1
CC_Indirect_Fgf1.Fgfr2
CC_Indirect_Fgf2.Fgfr1
CC_Indirect_Fgf2.Fgfr2
CC_Indirect_Fgf9.Fgfr1
CC_Indirect_Fgf9.Fgfr2
CC_Indirect_GALECTIN
CC_Indirect_GAS
CC_Indirect_GRN
CC_Indirect_Gas6.Axl
CC_Indirect_Gas6.Mertk
CC_Indirect_Grn.Sort1
CC_Indirect_Hbegf.Egfr
CC_Indirect_Hbegf.Erbb4
CC_Indirect_IGF
CC_Indirect_Igf1.Igf1r
CC_Indirect_Igf1.Itga6_Itgb4
CC_Indirect_Igf1.Itgav_Itgb3
CC_Indirect_Igf2.Igf1r
CC_Indirect_Igf2.Igf2r
CC_Indirect_Igf2.Itga6_Itgb4
CC_Indirect_Igf2.Itgav_Itgb3
CC_Indirect_Il34.Csf1r
CC_Indirect_KIT
CC_Indirect_Kitl.Kit
CC_Indirect_Lgals9.Cd44
CC_Indirect_Lgals9.Ptprc
CC_Indirect_NPR1
CC_Indirect_NRG
CC_Indirect_NT
CC_Indirect_Nampt.Insr
CC_Indirect_Nampt.Itga5_Itgb1
CC_Indirect_Nppa.Npr1
CC_Indirect_Nrg1.Erbb3
CC_Indirect_Nrg1.Erbb4
CC_Indirect_Nrg1.Itgav_Itgb3
CC_Indirect_Nrg2.Erbb3
CC_Indirect_Nrg2.Erbb4
CC_Indirect_Ntf3.Ntrk2
CC_Indirect_Ntf3.Ntrk3
CC_Indirect_PDGF
CC_Indirect_PERIOSTIN
CC_Indirect_PROS
CC_Indirect_PTN
CC_Indirect_Pdgfa.Pdgfra
CC_Indirect_Pdgfa.Pdgfrb
CC_Indirect_Pdgfb.Pdgfra
CC_Indirect_Pdgfb.Pdgfrb
CC_Indirect_Pdgfc.Pdgfra
CC_Indirect_Pdgfd.Pdgfrb
CC_Indirect_Postn.Itgav_Itgb3
CC_Indirect_Postn.Itgav_Itgb5
CC_Indirect_Pros1.Axl
CC_Indirect_Ptn.Itgav_Itgb3
CC_Indirect_Ptn.Ncl
CC_Indirect_Ptn.Ptprz1
CC_Indirect_Ptn.Sdc2
CC_Indirect_Ptn.Sdc4
CC_Indirect_RANKL
CC_Indirect_Rarres2.Cmklr1
CC_Indirect_SEMA3
CC_Indirect_Sema3a.Nrp1_Plxna2
CC_Indirect_Sema3a.Nrp1_Plxna4
CC_Indirect_Sema3c.Nrp1_Plxna2
CC_Indirect_Sema3c.Nrp1_Plxna4
CC_Indirect_Sema3c.Plxnd1
CC_Indirect_Sema3e.Plxnd1
CC_Indirect_TGFb
CC_Indirect_Tgfa.Egfr
CC_Indirect_Tgfb1.Acvr1_Tgfbr1_Tgfbr2
CC_Indirect_Tgfb1.Tgfbr1_Tgfbr2
CC_Indirect_Tgfb2.Acvr1_Tgfbr1_Tgfbr2
CC_Indirect_Tgfb2.Tgfbr1_Tgfbr2
CC_Indirect_Tnfsf11.Tnfrsf11a
CC_Indirect_Tnfsf11.Tnfrsf11b
CC_Indirect_VEGF
CC_Indirect_VISFATIN
CC_Indirect_Vegfa.Flt1
CC_Indirect_Vegfa.Flt1_Kdr
CC_Indirect_Vegfa.Kdr
CC_Indirect_Vegfb.Flt1
CC_Indirect_Vegfc.Flt4
CC_Indirect_Vegfc.Flt4_Kdr
CC_Indirect_Vegfc.Kdr
CC_Indirect_Vegfd.Flt4
CC_Indirect_Vegfd.Flt4_Kdr
CC_Indirect_Vegfd.Kdr
CC_Indirect_WNT
CC_Indirect_Wnt5a.Fzd4
CC_Indirect_Wnt5a.Fzd6
CC_Indirect_Wnt5a.Mcam
CC_Indirect_Wnt5b.Fzd4
CC_Indirect_Wnt5b.Fzd6
CC_Indirect_Wnt9a.Fzd4_Lrp5
CC_Indirect_Wnt9a.Fzd4_Lrp6
CC_Indirect_Wnt9a.Fzd6_Lrp5
CC_Indirect_Wnt9a.Fzd6_Lrp6
CC_Indirect_ncWNT
CC_Indirect_total.total
  `),
  tf: lines(`
TF_Meis2
TF_Pbx1
TF_Irx5
TF_Irx2
TF_Sox4
TF_Rorb
TF_Bcl11a
TF_Gata6
TF_Mef2a
TF_Gata4
TF_Rb1
TF_Suz12
TF_Tfdp1
TF_Mybl2
TF_Brca1
TF_E2f1
TF_E2f2
TF_Mybl1
TF_E2f8
TF_Sf1
TF_Chd1
TF_E2f7
TF_E2f3
TF_Pbx3
TF_Hmga2
TF_Srebf2
TF_Sp1
TF_Gabpb1
TF_Crem
TF_Gtf3c2
TF_Smarca4
TF_Phf8
TF_Taf1
TF_Sin3a
TF_Arnt
TF_Rcor1
TF_Sp3
TF_Creb1
TF_Stat5a
TF_Ppard
TF_Bach1
TF_Nfe2l2
TF_Max
TF_Foxo3
TF_Tef
TF_Cebpb
TF_Dbp
TF_Dnmt3a
TF_Nr4a1
TF_Atf6
TF_Atf1
TF_Ppargc1a
TF_Hif1a
TF_Esrrg
TF_Rarb
TF_Mef2d
TF_Esrra
TF_Thrb
TF_Esrrb
TF_Ppara
TF_Stat3
TF_Atf3
TF_Fosl2
TF_Pax5
TF_Zfp831
TF_Batf
TF_Hsf3
TF_Mafb
TF_Runx3
TF_Irf4
TF_Irf5
TF_Arid3a
TF_Maf
TF_Jund
TF_Jun
TF_Tead2
TF_Setdb1
TF_E2f6
TF_Gabpa
TF_Mafg
TF_Zfp410
TF_Zfp397
TF_Rfx2
TF_Hlf
TF_Vdr
TF_Esr2
TF_Nfic
TF_Foxp4
TF_Hivep2
TF_Egr3
TF_Hivep1
TF_Pax3
TF_Sox10
TF_Gata3
TF_Smad9
TF_Lef1
TF_Gata5
TF_Nr2f2
TF_Rela
TF_Stat2
TF_Irf9
TF_Irf1
TF_Stat1
TF_Sox7
TF_Tal1
TF_Sox17
TF_Gata2
TF_Elk3
TF_Ets2
TF_Tbx3
TF_Mef2c
TF_Klf10
TF_Egr1
TF_Irf8
TF_Creb3l2
TF_Tcf7l2
TF_Tcf7l1
TF_Foxp2
TF_Gli3
TF_Gli2
TF_Gli1
TF_Nfkb1
TF_Zfp385a
TF_Yy1
TF_Kdm5a
TF_Irf2
TF_Nr3c1
TF_Klf2
TF_Klf4
TF_Klf3
TF_Zmiz1
TF_Foxo1
TF_Foxp1
TF_Etv6
TF_Fli1
TF_Erg
TF_Ets1
TF_Elk4
TF_Klf6
TF_Pou2f2
TF_Ikzf1
TF_Runx1
TF_Fez1
TF_Stat6
TF_Relb
TF_Cebpg
TF_Meis1-extended
TF_Tbx5-extended
TF_Xrcc4-extended
TF_Ezh2-extended
TF_Rad21-extended
TF_Tcf12-extended
TF_Zfp369-extended
TF_Brf1-extended
TF_Tbl1xr1-extended
TF_Nr2c2-extended
TF_Atf2-extended
TF_Vezf1-extended
TF_Zfp612-extended
TF_Cpeb1-extended
TF_Nr1d2-extended
TF_Klf15-extended
TF_Bcl6-extended
TF_Ddit3-extended
TF_Bhlhe40-extended
TF_Bdp1-extended
TF_Stat5b-extended
TF_Elf2-extended
TF_Cux1-extended
TF_Rreb1-extended
TF_Nr3c2-extended
TF_Rxrg-extended
TF_Cebpa-extended
TF_Lyl1-extended
TF_Hdac2-extended
TF_Ubtf-extended
TF_Zfp384-extended
TF_Zfp213-extended
TF_Usf2-extended
TF_Foxk1-extended
TF_Rest-extended
TF_Zfp110-extended
TF_Hoxd4-extended
TF_Smarcc2-extended
TF_Nfe2l1-extended
TF_Rbbp5-extended
TF_Zfp523-extended
TF_Etv5-extended
TF_Ep300-extended
TF_Nr1d1-extended
TF_Trp213-extended
TF_Isx-extended
TF_Tbx2-extended
TF_Nfatc4-extended
TF_Nr1h3-extended
TF_Tead4-extended
TF_Prdm1-extended
TF_Pparg-extended
TF_Nr5a2-extended
TF_Foxc1-extended
TF_Creb5-extended
TF_Nfat5-extended
TF_Twist2-extended
TF_Tbx18-extended
TF_Ar-extended
TF_Creb3l1-extended
TF_Tcf21-extended
TF_Mta3-extended
TF_Msc-extended
TF_Pknox2-extended
TF_Cebpd-extended
TF_Glis2-extended
TF_Ctcf-extended
TF_Mxi1-extended
TF_Elf1-extended
TF_Bclaf1-extended
TF_Smad1-extended
TF_Sox13-extended
TF_Tcf4-extended
TF_Zbtb7a-extended
  `),
};
